import { useTranslate, useBack, HttpError } from '@refinedev/core';
import { Edit, useForm } from '@refinedev/antd';
import { Button, Form, Input, Typography } from 'antd';
import type {
  MonetizationProductDetailOut,
  MonetizationProductLocalizedNameIn,
} from '@/api/generated/schemas';

const { Text } = Typography;

export const MonetizationProductEdit = () => {
  const t = useTranslate();
  const back = useBack();
  const { formProps, saveButtonProps, query } = useForm<
    MonetizationProductDetailOut,
    HttpError,
    MonetizationProductLocalizedNameIn
  >({
    resource: 'monetization.products',
    mutationMeta: { method: 'patch' },
    redirect: 'show',
  });
  const record = query?.data?.data;

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      footerButtons={({ saveButtonProps: sbp }) => (
        <>
          <Button onClick={back}>{t('actions.cancel')}</Button>
          <Button type="primary" {...sbp}>
            {t('actions.save')}
          </Button>
        </>
      )}
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label={t('monetization.products.fields.revenuecat_product_id')}
        >
          <Text>{record?.revenuecat_product_id ?? '-'}</Text>
        </Form.Item>

        <Form.Item label={t('monetization.products.fields.display_name')}>
          <Text type="secondary">{record?.display_name ?? '-'}</Text>
        </Form.Item>

        <Form.Item
          name={['localized_display_name', 'en']}
          label={t('monetization.products.fields.localized_display_name_en')}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name={['localized_display_name', 'pl']}
          label={t('monetization.products.fields.localized_display_name_pl')}
        >
          <Input />
        </Form.Item>
      </Form>
    </Edit>
  );
};
